import { useContext } from "react";
import { CartContext } from "../context";
import { UseCartContextType } from "../models";

const useCart = (): UseCartContextType => {
  return useContext(CartContext);
};
export default useCart;
